import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type IndeedFlexLongTermAssignmentPreviewShift = {
  ifShiftId: number
  startTime: string
  endTime: string
  workersNeeded: number
  timezone: string
}

export type ListIndeedFlexLongTermAssignmentPreviewParams = {
  ifClientId: number
  ifJobId: number
}

export type ListIndeedFlexLongTermAssignmentPreviewResponse = {
  items: IndeedFlexLongTermAssignmentPreviewShift[]
}

export const listIndeedFlexLongTermAssignmentPreview = async (
  params: ListIndeedFlexLongTermAssignmentPreviewParams
): Promise<ListIndeedFlexLongTermAssignmentPreviewResponse> => {
  const response =
    await api.get<ListIndeedFlexLongTermAssignmentPreviewResponse>(
      '/admin/indeed_flex/long_term_assignments/preview',
      {
        params: {
          if_client_id: params.ifClientId,
          if_job_id: params.ifJobId,
        },
        paramsSerializer: queryParamSerializer,
      }
    )
  return response.data
}
